import { BreathingButton } from "../enum/breathing-button";
import { IBreathingScreen } from "../interfaces/IBreathingScreen";

export const BREATHING_COMPLETE_SCREEN: IBreathingScreen = {
  step: "Complete",
  title: "You did great! \nNotice how you feel.",
  buttons: [BreathingButton.anotherExercise],
};
